module.exports = __webpack_public_path__ + "img/alphera-logo.e7ea45ef.svg";